function formatBytes( bytes: number, decimals = 2 ) {

    const { i, bytenum } = getBytes( bytes, decimals );
    
    if ( bytenum === 0 ) return '0 Bytes';

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return `${bytenum} ${sizes[i]}`;
}

function getBytes( bytes: number, decimals = 2 ): { i: number; bytenum: number } {

    const k = 1024;

    const dm = decimals < 0 ? 0 : decimals;

    const i = Math.floor( Math.log( bytes ) / Math.log( k ) );

    return {
        i,
        bytenum: parseFloat( ( bytes / Math.pow( k, i ) ).toFixed( dm ) )
    };
}

export {
    formatBytes,
    getBytes
}